import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import TextInputArea from './App';

ReactDOM.render(
  <React.StrictMode>
    <TextInputArea />
  </React.StrictMode>,
  document.getElementById('root')
);